import { LinkButton } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import React from 'react';

const resetButtonStyles = css`
  font-size: 0.875rem;
  line-height: 24px;

  @media ${mediaQueries.medium.up} {
    display: flex;
    flex: 1 1 100%;
    margin: 4px 0 8px;
  }
`;

interface ResetButtonProps {
  dataTestId: string;
  onClick: (e: React.MouseEvent) => void;
}

const ResetButton = ({ dataTestId, onClick }: ResetButtonProps) => {
  const { t } = useTranslation();

  return (
    <LinkButton className={resetButtonStyles} data-testid={dataTestId} onClick={onClick}>
      {t('Result.SearchFilters.ResetFilter.Button')}
    </LinkButton>
  );
};

export default ResetButton;
